import React, { useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { lighten, withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ReportPropertiesForm from "./ReportPropertiesForm";
import { config, formatPercent, resolveNotificationMessage, createPercentageBar } from '../helpers/constants';
import NewProjectForm from "./../components/NewProjectForm";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { Typography, RadioGroup, FormControlLabel, CircularProgress, Box, Button, Divider, Radio, MenuItem, Switch, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Service from "../services/service";
import DividerLabel from './DividerLabel';
import IconLabel from './IconLabel';

const backgroundBar = (percent, l) => {
  return (percent > 10) ? lighten("#BE0A00", l) : lighten("#017D01", l);
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: '100%',
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    opacity: "0.9",
  },
  result_box: {
    flex: "0 0 120",
    display: "block",
    height: 120,
    padding: "0 10px",
    paddingBottom: "10px !important",
  },
  result_pending: {
    paddingTop: 20,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  expansion_block: {
    flex: "1 1 0",
    minHeight: 0,
    padding: "10px 10px 0px 10px",
    overflow: "hidden",
    overflowY: "auto",
  },

  linprog: {
    height: 40,
    marginTop: 8,
    //backgroundImage: "url(/gfx/colorbar.png)",
    backgroundColor: "#dddddd"
  },
  bar: {
    //backgroundImage: "url(/gfx/brushed-alum.png)",
    backgroundColor: (state) => {
      return backgroundBar(state.activeReport.ResultPercent, 0);
    },
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.5)",
  },

  content: {
    flex: "1 1 auto",
  },
  justify_content: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  alignText: {
    padding: "16px"

  },
  date_format: {
    padding: "0 !important",
  },
  progress_info: {
    textAlign: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "100% 100%",
  },
  reportOverviewImage: {
    marginTop: 10,
    marginBottom: 5,
  },
  percent_parent: {
    position: "relative",
    width: "100%"
  },
  percent_pos: {
    marginTop: 10,
    width: "100%",
    textAlign: "center",
    color: "#0D4A81",
    fontWeight: "400",
    fontSize: 30,
    textShadow: "1px 1px 3px #ffffff"
  },
  expansion_details: {
    padding: "0 !important",
  },
  pannelSummary: {
    padding: "0 16px",
  },
  plag_word: {
    color: "#f16b5b",
  },
  plag_block: {
    fontWeight: "500",
  },
  action_block: {
    textAlign: "center",
    paddingBottom: "10px"
  },
  update_padding: {
    padding: 0,
  },
  button_block: {
    width: '90%',
    margin: '0 5%'
  },
  selectReport: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "1 1 auto",
    margin: theme.spacing(2),
    textAlign: "center",
  }

}));


const Accordion = withStyles({

  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    width: "100%",
    backgroundColor: '#ffffff',
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#F7F7F7",
    borderBottom: "1px solid #E6E6E6",
    marginBottom: -1,
    minHeight: 40,
    height: 40,
    "&$expanded": {
      minHeight: 40,
      height: 40,
      backgroundColor: "#E6E6E6",
    },
    '&:hover': {
      cursor: "pointer",
      backgroundColor: "#EEEEEE",
      transition: 'background-color 0.2s',
    },
  },

  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function ReporDetails(props) {
  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);
  const classes = useStyles(state);
  const [expanded, setExpanded] = React.useState("panel1");
  const { view, onResetReport } = props;

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  if (!state.activeReportId) {
    return (
      <div className={classes.root}>
        <div className={classes.selectReport}>
          <SearchIcon fontSize="large" color="primary" />
          <Box mt={3} />
          <Typography paragraph>{s.reportOverview.selectReport}</Typography>
          <Typography variant="body2" color="primary">{s.reportOverview.selectReportHint}</Typography>
        </div>
      </div>
    );
  }


  const handleCheckRevision = () => {
    dispatch(actions.setNewCheckSettings({ revisionReportId: state.activeReportId }));
    dispatch(actions.navigate_to(`/plagiarism/new`));
  }

  const handleResetReport = () => {
    dispatch(actions.openConfirmationDialog({
      title: s.reportReview.resetReport,
      text: s.reportReview.resetReportText,
      hint: s.reportReview.resetReportHint,
      waitingMessage: s.reportReview.resettingReport,
      onConfirm: () => resetReport(state.activeReportId)
    }));
  }

  const resetReport = (reportId) => {
    Service.resetReport(reportId, state.ui.permaLinkId).then(res => {
      dispatch(actions.closeConfirmationDialog());
      if (res.success) {
        onResetReport();
        dispatch(actions.openToast({ type: "success", message: s.notificationMessage.resetReport, status: true }));
      }
      else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    })
  }

  const changeDisplayMode = (event) => {
    dispatch(actions.setUI({ reportDisplayMode: event.target.value }));
  };

  const changeStatisticsMode = (event) => {
    dispatch(actions.setUI({ statisticsMode: event.target.value }));
  };

  const handleTruncateTextChanged = (checked) => {
    dispatch(actions.setUI({ showTextWithoutMarkup: checked }));
  }

  const handleShowLinebreaksChanged = (checked) => {
    dispatch(actions.setUI({ showLinebreaks: checked }));
  }



  const percentValue = state.activeReport && state.activeReport.ResultPercent;

  return (
    <div className={classes.root}>
      {state.openCreateProjectPopup && <NewProjectForm />}
      {state.activeReport && state.activeReport.Status === "Ok" &&
        <div className={classes.result_box}>
          {true &&
            <>
              <div className={classes.percent_parent} >
                <div style={{ backgroundImage: `url(${config.backendUrl}button?percent=${percentValue}&size=3` }} className={classes.percent_pos}>
                  {formatPercent(state.activeReport.ResultPercent)}%
                </div>
                <img
                  src={`${config.backendUrl}button/?reportid=${state.activeReport.Id}&size=1&nc=${Math.random(1)}`}
                  alt="new"
                  className={classes.reportOverviewImage}
                />

              </div>
              <div className={classes.justify_content}>
                <Typography>{s.reportReview.wordsCopied.format(state.activeReport.PlagWords || 0, state.activeReport.TotalWords)}</Typography>
              </div>
            </>}
        </div>}
      {state.activeReport && state.activeReport.Status !== "Ok" &&
        <div className={classes.result_box}>
          <div className={classes.result_pending}>
            {state.activeReport.Status == "Aktiv" &&
              <>
                <CircularProgress size={30} />
                <Typography color="primary" variant="body1">{s.reportOverview.reportActive}</Typography>
              </>}
            {state.activeReport.Status == "Geplant" &&
              <>
                <AccessTimeIcon color="primary" fontSize="large" />
                <Typography color="primary" variant="body1">{s.reportOverview.reportScheduled}</Typography>
              </>}
            {state.activeReport.Status == "Fehler" &&
              <IconLabel type="error" label={resolveNotificationMessage(state.activeReport.StatusCode, s.notificationMessage)} />}
          </div>
        </div>}
      <Divider />
      <div className={classes.expansion_block}>

        {/* Properties Panel Start */}
        <Accordion

          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            className={classes.pannelSummary}
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            {s.properties}
          </AccordionSummary>
          <AccordionDetails className={classes.expansion_details}>
            {state.loadingReportDetail && <ReportPropertiesForm className={classes.update_padding} report={state.activeReport} />}
          </AccordionDetails>
        </Accordion>
        {/* Properties Panel End */}

        {/* View Panel Start */}
        {!view &&
          <Accordion
            square
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              className={classes.pannelSummary}
              aria-controls="panel2d-content"
              id="panel2d-header"
            >
              {s.view}
            </AccordionSummary>
            <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
              <FormControlLabel className={classes.textField}
                control={<Switch checked={state.ui.showTextWithoutMarkup} disabled={state.ui.sourcesView != "sources" || state.ui.reportDisplayMode != 'merged'} onChange={(e) => handleTruncateTextChanged(e.target.checked)} />}
                label={s.reportReview.truncateReport}
              />
              <FormControlLabel className={classes.textField}
                control={<Switch checked={state.ui.showLinebreaks} disabled={state.ui.sourcesView == "sources" && state.ui.reportDisplayMode != 'merged'} onChange={(e) => handleShowLinebreaksChanged(e.target.checked)} />}
                label={s.reportReview.showLinebreaks}
              />

              {state.ui.sourcesView == "sources" &&
                <>
                  <DividerLabel label={s.reportReview.displayMode} />
                  <RadioGroup value={state.ui.reportDisplayMode} onChange={changeDisplayMode}>
                    <FormControlLabel value={'merged'} control={<Radio />} label={s.mergedReport} />
                    <FormControlLabel value={'source'} control={<Radio />} label={s.selectedSource} />
                  </RadioGroup>
                </>
              }
              {state.ui.sourcesView == "statistics" &&
                <>
                  <DividerLabel label={s.kiDetector.textOverlaySettings} />

                  <RadioGroup value={state.ui.statisticsMode} onChange={changeStatisticsMode}>
                    <FormControlLabel value={'md'} control={<Radio />} label={s.kiDetector.medianLabel} />
                    <FormControlLabel value={'bf'} control={<Radio />} label={s.kiDetector.bilateralLabel} />
                    <FormControlLabel value={'mn'} control={<Radio />} label={s.kiDetector.meanLabel} />
                    <FormControlLabel value={'v'} control={<Radio />} label={s.kiDetector.rawLabel} />
                  </RadioGroup>
                </>
              }
            </AccordionDetails>
          </Accordion>
        }
        {/* View Panel End */}

        {/* User Setting Panel Start */}
        <Accordion
          square
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            className={classes.pannelSummary}
            aria-controls="panel3d-content"
            id="panel3d-header"
          >
            {s.usedSettings}
          </AccordionSummary>
          <AccordionDetails className={classes.expansion_details}>
            <div className={classes.alignText}>
              <div data-for="globalTT" data-tip={s.maxGapTip}>{s.maxGap.format(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.MaxPhraseDistance)}</div>
              <div data-for="globalTT" data-tip={s.minPhraseLengthTip}>{s.minPhraseLength.format(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.MinRegionLength)}</div>
              <div data-for="globalTT" data-tip={s.minSourceLengthTip}>{s.minSourceLength.format(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.MWThreshold)}</div>
              <div data-for="globalTT" data-tip={s.reportReview.minSimilarityTip}>{s.reportReview.minSimilarity.format(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.MinSimilarity)}</div>
              <div>
                {s.sourceOnlineSearch}:&nbsp;
                {(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.WebSearch === 1) ? s.yes : s.no}
              </div>
              <div>
                {s.sourceLibrarySearch}:&nbsp;
                {(state.activeReport && state.activeReport.Settings && state.activeReport.Settings.LibrarySearch === 1) ? s.yes : s.no}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        {/* User Setting Panel End */}

        {/* Action Panel Start */}
        <Accordion
          square
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            className={classes.pannelSummary}
            aria-controls="panel4d-content"
            id="panel4d-header"
          >
            {s.actions}
          </AccordionSummary>
          <AccordionDetails className={classes.expansion_details}>
            <div style={{ width: '100%', paddingTop: '10px' }}>
              <div className={classes.action_block}>
                <Button className={classes.button_block} disabled={state.ui.permaLinkId || !state.activeReportId || !state.activeReport || state.activeReport.Status != "Ok"} type="submit" variant="contained" color="primary" onClick={handleCheckRevision}>
                  {s.checkRevision}
                </Button>
              </div>
              <div className={classes.action_block}>
                <Button className={classes.button_block} disabled={state.activeReport.ReadOnly || !state.activeReportId || !state.activeReport || state.activeReport.Status != "Ok"} type="submit" variant="contained" color="primary" onClick={handleResetReport}>
                  {s.resetReport}
                </Button>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        {/* Action Panel End */}
      </div>
    </div>
  );
};
